import { render, staticRenderFns } from "./RecruitAgent.vue?vue&type=template&id=218fffce&scoped=true&"
import script from "./RecruitAgent.vue?vue&type=script&lang=js&"
export * from "./RecruitAgent.vue?vue&type=script&lang=js&"
import style0 from "./RecruitAgent.vue?vue&type=style&index=0&id=218fffce&scoped=true&lang=scss&"
import style1 from "./RecruitAgent.vue?vue&type=style&index=1&id=218fffce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218fffce",
  null
  
)

export default component.exports